import React, { FC, ReactNode } from "react";
import { ErrorBoundary as TestingErrorBoundary } from "react-error-boundary";

interface Props {
  children: ReactNode;
}

export const ExceptionMonitorProvider: FC<Props> = ({ children }) => {
  return process.env.RAILS_ENV === "test" ? (
    <TestingErrorBoundary
      fallbackRender={({ error }) => (
        <div role="alert">
          <p>Something went wrong:</p>
          <pre>{error.message}</pre>
        </div>
      )}
    >
      {children}
    </TestingErrorBoundary>
  ) : (
    <>{children}</>
  );
};
